import { Component, Inject, OnInit } from '@angular/core';
import { TextProposal } from './textkuerzel';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { TextTableColumn } from '../../components/kiene-table/table-column';
import { TableOption } from '../../components/kiene-table/table-option';
import { TextProposalService } from './text-proposal.service';

@Component({
    selector: 'kiene-text-autocomplete',
    templateUrl: './text-autocomplete.component.html',
    styleUrls: ['./text-autocomplete.component.scss'],
})
export class TextAutocompleteComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        private readonly api: KieneTableService,
        private readonly messageService: MessageService,
        private readonly service: TextProposalService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Text Autovervollständigung';
        this.tableDescriptor.uniqueIdentifier = 'Text Autovervollständigung';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'textkuerzel/';
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetails = true;
        this.tableDescriptor.showDetailsVoid = this.openEditTextkuerzelDialog.bind(this);

        this.tableDescriptor.columns = this.getTableColumns();
        this.tableDescriptor.options = this.getTableOptions();

        this.tableDescriptor.initialSortColumn = 'textkuerzel';

        this.tableDescriptor.permissionView = 1411;
        this.tableDescriptor.permissionCreate = 1412;
        this.tableDescriptor.addVoid = this.openAddTextProposalDialog.bind(this);
    }

    getTableColumns() {
        const columns = [];
        columns.push(new TextTableColumn('textkuerzel', 'Kürzel'));
        columns.push(new TextTableColumn('wortgruppe', 'Text'));
        return columns;
    }

    getTableOptions() {
        const options = [];
        options.push(new TableOption(this.openEditTextkuerzelDialog.bind(this), 'bearbeiten', 'edit', 1413));
        options.push(new TableOption(this.deleteTextProposal.bind(this), 'löschen', 'delete', 1414));
        return options;
    }

    openAddTextProposalDialog() {
        this.dialog
            .open(AddTextkuerzelDialog, { width: '700px' })
            .afterClosed()
            .subscribe(() => {
                () => {
                    this.messageService.infoMessage('Textkuerzel erfolgreich gespeichert!');
                    this.api.reload('openAddTextProposalDialog');
                };
            });
    }

    openEditTextkuerzelDialog(row: TextProposal) {
        this.dialog
            .open(EditTextkuerzelDialog, { width: '700px', data: row })
            .afterClosed()
            .subscribe((result: TextProposal) => {
                if (result) {
                    this.messageService.infoMessage('Textkuerzel erfolgreich gespeichert!');
                    this.api.reload('openEditTextkuerzelDialog');
                }
            });
    }

    deleteTextProposal(textProposal: TextProposal) {
        this.service.deleteTextProposal(textProposal).subscribe(
            () => {
                this.messageService.infoMessage(
                    'Tierarztgruppe ' + textProposal.textkuerzel + ' erfolgreich entfernt!',
                );
                this.api.reload('deleteTextProposal');
            },
            error => {
                console.error(error);
                this.messageService.errorMessage(
                    'Löschen von Tierarztgruppe ' + textProposal.textkuerzel + ' ist fehlgeschlagen!',
                    error,
                );
            },
        );
    }
}

@Component({
    selector: 'edit-textkuerzel-dialog',
    template: `<h1 mat-dialog-title>Text f&uuml;r K&uuml;rzel {{ textProposal?.textkuerzel }} &auml;ndern</h1>
        <mat-dialog-content>
            <mat-form-field style="width: 100%;">
                <mat-label>K&uuml;rzel</mat-label>
                <input type="text" matInput placeholder="Kürzel" [(ngModel)]="textProposal.textkuerzel" />
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Text ($ als Platzhalter)</mat-label>
                <input type="text" matInput [(ngModel)]="textProposal.wortgruppe" />
            </mat-form-field>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-button (click)="onCancelClick()">Abbrechen</button>
            <button mat-flat-button color="accent" (click)="closeAndSafe()">Speichern</button>
        </mat-dialog-actions>`,
})
export class EditTextkuerzelDialog {
    constructor(
        public dialogRef: MatDialogRef<EditTextkuerzelDialog>,
        @Inject(MAT_DIALOG_DATA) public textProposal: TextProposal,
        private service: TextProposalService,
        private messageService: MessageService,
    ) {}

    closeAndSafe() {
        this.service.updateTextProposal(this.textProposal).subscribe({
            next: (response: TextProposal) => {
                this.dialogRef.close(response);
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }

    onCancelClick(): void {
        this.dialogRef.close(null);
    }
}

@Component({
    selector: 'add-textkuerzel-dialog',
    template: `<h1 mat-dialog-title>Textk&uuml;rzel hinzuf&uuml;gen</h1>
        <mat-dialog-content>
            <mat-form-field style="width: 100%;">
                <mat-label>K&uuml;rzel</mat-label>
                <input type="text" matInput placeholder="Kürzel" [(ngModel)]="textProposal.textkuerzel" />
            </mat-form-field>
            <mat-form-field style="width: 100%;">
                <mat-label>Text ($ als Platzhalter)</mat-label>
                <input type="text" matInput [(ngModel)]="textProposal.wortgruppe" />
            </mat-form-field>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-button (click)="onCancelClick()">Abbrechen</button>
            <button mat-flat-button color="accent" (click)="closeAndSafe()">Speichern</button>
        </mat-dialog-actions>`,
})
export class AddTextkuerzelDialog {
    constructor(
        public dialogRef: MatDialogRef<AddTextkuerzelDialog>,
        private service: TextProposalService,
        private messageService: MessageService,
        @Inject(MAT_DIALOG_DATA) public textProposal: TextProposal,
    ) {
        if (!this.textProposal) {
            this.textProposal = new TextProposal();
        }
    }

    closeAndSafe() {
        this.service.createTextProposal(this.textProposal).subscribe({
            next: (response: TextProposal) => {
                this.dialogRef.close(response);
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }

    onCancelClick(): void {
        this.dialogRef.close(null);
    }
}
